module.exports = __webpack_public_path__ + "img/invoice.71f12e15.svg";